import styled from 'styled-components'
import colors from 'utils/colors'
import CustomText from 'components/text/CustomText'
import { BUTTONS, TITLES } from 'locales/locales'
import { useTranslation } from 'react-i18next'
import CustomButton from 'components/button/CustomButton'
const SelectionBar = ({
  selectedMessages,
  handleCancelSelection,
  handleCompleteSelection,
  type
}: {
  selectedMessages: string[]
  handleCancelSelection: () => void
  handleCompleteSelection: () => void
  type: 'message' | 'thread'
}) => {
  const { t } = useTranslation()
  return (
    <StyledSelectionBar type={type}>
      <SelectionInfo type={type}>
        <CustomText typography="body2" color={colors.white}>
          {selectedMessages.length} {t(TITLES.SELECTED_MESSAGE)}
        </CustomText>
      </SelectionInfo>
      <SelectionActions>
        <CancelButton
          text={t(BUTTONS.CANCEL)}
          onClick={handleCancelSelection}
          buttonType="button"
          textColor={colors.white}
        />
        <CustomButton
          text={t(BUTTONS.FORWARD_TO_ROOMS)}
          onClick={handleCompleteSelection}
          disabled={selectedMessages.length === 0}
          buttonType="submit"
          textColor={colors.white}
        />
      </SelectionActions>
    </StyledSelectionBar>
  )
}

export default SelectionBar

const StyledSelectionBar = styled.div<{ type: 'message' | 'thread' }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${colors.light100};
  border-top: 1px solid ${colors.light80};
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  margin: 5px 30px 0px 30px;
  ${({ type }) => type === 'thread' && `
    margin: 5px 30px 0px 30px;
  `}
`

const SelectionInfo = styled.div<{ type: 'message' | 'thread' }>`
  display: flex;
  align-items: center;
  margin-left: 25px;
  ${({ type }) => type === 'thread' && `
    margin-left: 0px;
  `}
`

const SelectionActions = styled.div`
  display: flex;
  gap: 16px;
`

const CancelButton = styled(CustomButton)`
  background-color: ${colors.red};
  &:hover {
    background-color: ${colors.secondaryRed};
  }
`

